import { useEffect, useState } from 'react';
import { fetchAssessment, type AssessmentResponse } from '@/lib/api/assessment';

export function useSessionAssessment(sessionId: string | undefined) {
  const [assessment, setAssessment] = useState<AssessmentResponse | null>(null);
  const [loading, setLoading] = useState(Boolean(sessionId));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!sessionId) {
      setAssessment(null);
      setLoading(false);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    void fetchAssessment(sessionId)
      .then((data) => {
        if (cancelled) return;
        setAssessment(data);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'assessment_failed');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return { assessment, loading, error };
}
